"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var PreviewBox_1 = require("../PreviewBox/PreviewBox");
var SpotComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SpotComponent, _super);
    function SpotComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.spot-two_plus_one .spot-link';
        return _this;
    }
    SpotComponent.prototype.OnInit = function () {
        this.el.forEach(function (el) {
            var href = el.getAttribute('href');
            var playButtonAriaLabel = el.getAttribute('data-play-button-aria-label');
            var popupAriaLabel = el.getAttribute('data-popup-aria-label');
            var closeButtonAriaLabel = el.getAttribute('data-close-button-aria-label');
            if (!webexUI_1.VideoService.checkIsValidVideo(href)) {
                return true; // go to next iteration
            }
            el.addEventListener('click', function (event) {
                event.preventDefault();
            });
            el.classList.add('spot-link-disable-hover');
            var playButton = SpotComponent.createMediaButton(playButtonAriaLabel);
            playButton.addEventListener('click', function () {
                (0, PreviewBox_1.renderPreviewBox)(href, popupAriaLabel, closeButtonAriaLabel);
            });
            playButton.addEventListener('keypress', function (event) {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.renderPreviewBox)(href, popupAriaLabel, closeButtonAriaLabel);
                }
            });
            el.querySelector('.spot-image-container ').appendChild(playButton);
        });
    };
    SpotComponent.createMediaButton = function (playButtonAriaLabel) {
        var button = document.createElement('button');
        var ctaContent = document.createElement('span');
        var ctaContentIcon = document.createElement('span');
        var ctaContentText = document.createElement('span');
        button.classList.add('cta cta--with-icon cta--alpha cta--play-video');
        button.setAttribute('aria-label', playButtonAriaLabel);
        ctaContent.classList.add('cta-content');
        ctaContentIcon.classList.add('icon icon-play');
        ctaContentText.classList.add('cta-content-text');
        ctaContent.appendChild(ctaContentIcon);
        ctaContent.appendChild(ctaContentText);
        button.appendChild(ctaContent);
        return button;
    };
    return SpotComponent;
}(app_1.Component));
exports.SpotComponent = SpotComponent;
exports.promoVideoComponent = new SpotComponent();
